<i18n>
{
	"en": {
		"TodoStatistic": "Todo statistic",
		"InTheLast30Days": "In the last 30 days"
	},
	"vi": {
		"TodoStatistic": "Thống kê công việc",
		"InTheLast30Days": "Trong 30 ngày gần nhất"
	}
}
</i18n>

<template>
	<div class="list-todo-statistics cbs-custom-table">
		<div class="header flex flex-col md:flex-row justify-between items-center">
			<div class="flex flex-col md:flex-row items-center pt-4 md:pt-0">
				<h4 class="header__title md:py-6 md:pl-6 ">{{ $t("TodoStatistic") }}</h4>
				<p class="ml-0 md:ml-4">{{ $t("InTheLast30Days") }}</p>
			</div>
			<div class="flex flex-row justify-center md:justify-end pr-0 md:pr-6 px-2 md:px-0">
				<div class="ml-2 md:ml-12 " v-for="des in statusDescriptions" :key="des.color">
					<span class="statistics-description inline-block mr-1 md:mr-2" :style="{ backgroundColor: des.color }"></span>
					<span class="text-sm md:text-base whitespace-no-wrap">{{ des.name }}</span>
				</div>
			</div>
		</div>

		<div class="p-3 flex flex-wrap items-container list-todo-statistics__items-container">
			<div class="w-full sm:w-1/2 lg:w-1/3 items-container__item" v-for="(item, index) in statisticData" :key="index">
				<todo-statistic class="m-0 mt-3 md:m-3" :department="item.id" :title="item.name" :data="item.data" :labels="item.labels" />
			</div>
		</div>
	</div>
</template>

<script>
import todolistGQL from "@/http/requests/cbs/todo_list_gql.js";

import TodoStatistic from "./TodoStatistic";

export default {
	name: "ListTodoStatistics",
	components: {
		TodoStatistic
	},
	data() {
		return {
			statisticData: [],
			statusDescriptions: [
				{ name: this.$t("OutOfDate"), color: "#EB5757" },
				{ name: this.$t("Doing"), color: "#2B59B2" },
				{ name: this.$t("Done"), color: "#219653" }
			]
		};
	},
	methods: {
		async getStatisticData() {
			try {
				this.$vs.loading();
				const response = (await todolistGQL.getTodoStatistic()) || [];
				this.statisticData = response.map(item => {
					const parsedCurrentValue = {
						data: [],
						labels: [],
						id: item.department.id,
						name: item.department.name
					};
					const detailData = item.details || [];
					let outOfDateData = {},
						doingData = {},
						completedData = {};

					detailData.forEach(data => {
						const parsedData = {
							...data,
							display: Number(data.display)
						};
						if (data.id === this.$constant.TODO_ITEM_STATUSES.STATUS_OUT_OF_DATE) {
							outOfDateData = parsedData;
						} else if (data.id === this.$constant.TODO_ITEM_STATUSES.STATUS_DOING) {
							doingData = parsedData;
						} else if (data.id === this.$constant.TODO_ITEM_STATUSES.STATUS_DONE || data.id === this.$constant.TODO_ITEM_STATUSES.STATUS_CLOSED) {
							completedData = parsedData;
						}

						parsedCurrentValue.labels = [outOfDateData.name, doingData.name, completedData.name];
						parsedCurrentValue.data = [outOfDateData.display, doingData.display, completedData.display];
					});

					return parsedCurrentValue;
				});
			} catch (error) {
				this.$helper.notifyError({ context: this, error });
			} finally {
				this.$nextTick(() => this.$vs.loading.close());
			}
		}
	},
	created() {
		this.getStatisticData();
	}
};
</script>

<style lang="scss" scoped>
.list-todo-statistics {
	.list-todo-statistics__items-container {
		.items-container__item {
			@media screen and (min-width: 1470px) {
				// width: 25% !important;
			}
		}
	}
	.statistics-description {
		width: 12px;
		height: 12px;
		border-radius: 50%;
	}
}
</style>
